import { render, staticRenderFns } from "./finished.vue?vue&type=template&id=d22ad72e&"
import script from "./finished.vue?vue&type=script&lang=ts&"
export * from "./finished.vue?vue&type=script&lang=ts&"
import style0 from "./finished.vue?vue&type=style&index=0&id=d22ad72e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports